export default __webpack_public_path__ + "static/figurky-01f8e13aaf32b061d5d5b7bb5a9e1767.png";